import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import NewsletterSignup from "@/components/NewsletterSignup";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function DigestPreviewPage() {
  const [digest, setDigest] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/digest/preview`)
      .then((res) => setDigest(res.data))
      .catch((err) => console.error("Digest preview error:", err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#FFF1E5]" data-testid="digest-preview-page">
      <SEO title="Weekly Digest" description="Preview the Farmwatch Friday Digest - weekly Irish mart prices, the Mart Report and the top farming stories, free to your inbox every Friday." url="/digest" />
      <Header />

      <section className="bg-gradient-to-r from-[#022C22] to-[#064E3B] py-8">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <span className="px-3 py-1 bg-[#FBBF24] text-[#022C22] text-xs font-mono uppercase tracking-wider">Free every Friday</span>
          <h1 className="font-serif text-3xl sm:text-4xl text-white mt-3 mb-2">The Farmwatch Weekly Digest</h1>
          <p className="text-[#A7F3D0] text-lg">This is exactly what lands in subscribers' inboxes — live preview built from this week's data</p>
        </div>
      </section>

      <main className="max-w-[720px] mx-auto px-4 py-10">
        {loading ? (
          <div className="flex justify-center py-16">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0F766E]"></div>
          </div>
        ) : digest?.html ? (
          <div className="border border-[#E0D4C8] shadow-sm" data-testid="digest-email-preview">
            <div className="bg-white border-b border-[#E0D4C8] px-4 py-3 text-sm text-[#6B6661]">
              <span className="font-semibold text-[#33302E]">Subject:</span> {digest.subject}
            </div>
            <div dangerouslySetInnerHTML={{ __html: digest.html }} />
          </div>
        ) : (
          <p className="text-center text-[#6B6661] py-16" data-testid="digest-preview-error">
            Preview unavailable right now — check back shortly.
          </p>
        )}
      </main>

      <NewsletterSignup compact />
      <Footer />
    </div>
  );
}
